// Only row is the idempotent 'Standard' insert (20260922120000), so the id is deterministic everywhere.
export var TransferOrderItemType;
(function (TransferOrderItemType) {
    TransferOrderItemType[TransferOrderItemType["STANDARD"] = 1] = "STANDARD";
})(TransferOrderItemType || (TransferOrderItemType = {}));
//# sourceMappingURL=transfer-order-item-type.js.map